/* ============================================================
   woody® — Such-Overlay (Snocks-getreu, woody-Sortiment)
   TEIL 2 von 2: JavaScript — Version 5
   ------------------------------------------------------------
   EINBAU:
   1) als "assets/woody-search.js" anlegen.
   2) in "layout/theme.liquid" direkt VOR </body>:
        <script src="{{ 'woody-search.js' | asset_url }}" defer></script>
   TEIL 1 (CSS) liegt in: snippets/woody-search.liquid

   Overlay (Vollbild, wie Snocks):
     - Beliebte Produkte = 4 Bestseller (Lukas Tabacco, Maxima, Max, Lea)
       + automatisch aufgefüllt auf 10 (weitere Schuh-Produkte).
       Karten: Bild, Titel, Untertitel (Produkttyp), Preis.
     - Beliebte Kategorien · Service · Artikel (Sidebar)
   Beim Tippen: Produkte = Live-Suchergebnisse, Kategorien = Treffer.

   Anpassen: Bestseller in BEST, Listen in defaultCats/SERVICE/ARTIKEL,
   Auffüll-Produkttypen in FILL_TYPES.
   PageSpeed: defer + Daten erst beim Fokus.
   ============================================================ */
(function () {
  function init() {
    if (window.__wspReady) return;
    var headerEl = document.getElementById('header');
    if (!headerEl) return;

    // 1) Bestseller (kommen zuerst). variant = optionale Varianten-ID.
    var BEST = [
      { label: 'Lukas Tabacco', handle: 'lukas-herren-clog-woody', variant: 49797764448595 },
      { label: 'Maxima', handle: 'maxima-damen-clog-pantolette' },
      { label: 'Max', handle: 'max-herren-clog-pantolette' },
      { label: 'Lea', handle: 'lea-damen-clog-woody' }
    ];
    // Auffüll-Produkte: diese Produkttypen werden zugelassen (Taschen/Pflege/Socken raus)
    var FILL_TYPES = { Sneaker: 1, Pantolette: 1, Sandalette: 1, Sandale: 1, Stiefel: 1, Stiefelette: 1, Clogs: 1, Fellschuh: 1 };
    var FILL_COUNT = 6; // 4 Bestseller + 6 = 10

    // Beliebte Kategorien — nach Geschlecht gesplittet
    var CAT_DAMEN = [
      ['Clogs', '/collections/clogs-damen'],
      ['Pantoletten', '/collections/pantoletten-damen-holzschuhe'],
      ['Sandalen', '/collections/sandalen-damen'],
      ['Sneakers', '/collections/sneakers-damen'],
      ['Stiefel', '/collections/stiefel-damen'],
      ['Fellschuhe', '/collections/fellmodelle-damen']
    ];
    var CAT_HERREN = [
      ['Clogs', '/collections/clogs-herren'],
      ['Pantoletten', '/collections/pantoletten-herren-holzschuhe'],
      ['Sandalen', '/collections/sandalen-herren'],
      ['Sneakers', '/collections/sneakers-herren'],
      ['Stiefel', '/collections/stiefel-stiefeletten-herren'],
      ['Fellschuhe', '/collections/fellmodelle-herren']
    ];
    var SERVICE = [
      ['Sohlentausch & Reparatur', '/products/sohlentausch-neubesohlung-reparatur-woodys'],
      ['Größentabelle', '/pages/richtige-groesse-finden'],
      ['Zahlung & Versand', '/pages/versand'],
      ['Reinigung & Pflege', '/pages/reinigung-pflege-woody-schuhe'],
      ['Fragen & Antworten', '/pages/woody-faq'],
      ['Manufaktur Outlet', '/pages/fabriksverkauf'],
      ['Kontakt', '/pages/kontakt-woody-holzschuhe']
    ];
    var ARTIKEL = [
      ['Handtaschen', '/collections/accessoires-handtaschen-gutscheine-woody'],
      ['Lederpflege', '/products/lederseife-woody-clogs-schuhe'],
      ['Geschenkgutscheine', '/products/onlineshop-gutschein'],
      ['Trachtenschuhe', '/collections/trachtenschuhe-clogs-dirdl-lederhose']
    ];

    function linkList(list) { return list.map(function (c) { return '<a href="' + c[1] + '">' + c[0] + '</a>'; }).join(''); }

    var backdrop = document.createElement('div'); backdrop.id = 'wsp-backdrop';
    var panel = document.createElement('div'); panel.id = 'wsp';
    // i18n-Texte + locale-echte URLs kommen server-seitig aus Liquid (siehe woody-search.liquid,
    // window.__wspI18n). assets/woody-search.js verarbeitet kein Liquid, darum dieser Handoff.
    // Fallbacks (DE) rein defensiv, falls das Handoff-Script mal nicht laeuft.
    var i18n = window.__wspI18n || {};
    var saleHint = i18n.saleHint;
    // WICHTIG: i18n.* NICHT durch esc() schicken -> Shopify's 't'-Filter escaped Sonderzeichen
    // (', ", &) im Liquid-Handoff bereits serverseitig (siehe woody-search.liquid). Nochmal esc()
    // hier wuerde das fuehrende '&' der Entity nochmal escapen -> sichtbares "&amp;#39;" im Overlay.
    // esc() bleibt nur fuer echte Laufzeit-Werte (User-Suchtext, API-Produktdaten), siehe unten.
    // SALE-Hinweis (saisonal) fest im Panel-Grundgeruest verankert (wie wsp-mainhead) -> bleibt bei
    // jedem Such-Zustand sichtbar, wird von showInitial()/showResults() nie neu geschrieben.
    var saleHintHtml = (saleHint && saleHint.text && saleHint.url)
      ? ('<a class="wsp-sale-hint" href="' + saleHint.url + '">' + saleHint.text + '</a>')
      : '';
    panel.innerHTML =
      '<div id="wsp-inner">' + saleHintHtml + '<div id="wsp-layout">' +
        '<div id="wsp-main"><div class="wsp-mainhead"><span class="wsp-h" id="wsp-title" style="margin:0">' + (i18n.popularProducts || 'Beliebte Produkte') + '</span>' +
          '<a class="wsp-all" id="wsp-all" href="' + (i18n.viewAllUrl || '/collections/clogs-holzschuhe-woody') + '">' + (i18n.viewAll || 'Alle ansehen') + '</a></div><div id="wsp-products"></div></div>' +
        '<aside id="wsp-side">' +
          '<div class="wsp-h first">' + (i18n.popularCategories || 'Beliebte Kategorien') + '</div><div id="wsp-cats"></div>' +
          '<div class="wsp-h">' + (i18n.service || 'Service') + '</div><div class="wsp-links">' + linkList(SERVICE) + '</div>' +
          '<div class="wsp-h">' + (i18n.articles || 'Artikel') + '</div><div class="wsp-links">' + linkList(ARTIKEL) + '</div>' +
        '</aside>' +
      '</div></div>';
    document.body.appendChild(backdrop);
    document.body.appendChild(panel);

    var products = panel.querySelector('#wsp-products');
    var catWrap = panel.querySelector('#wsp-cats');
    var titleEl = panel.querySelector('#wsp-title');
    var allEl = panel.querySelector('#wsp-all');
    var activeInput = null, bestCache = null, fillCache = null, debTimer = null;

    function euro(v) { var n = parseFloat(v); return isNaN(n) ? '' : '€ ' + n.toFixed(2).replace('.', ','); }
    function esc(s) { return (s || '').replace(/[&<>"]/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[m]; }); }
    function card(p) {
      var now = parseFloat(p.price), was = parseFloat(p.compareAt);
      var priceBlock = (was && was > now)
        ? '<span class="p-sale">' + euro(now) + '</span><span class="p-was">' + euro(was) + '</span>'
        : euro(p.price);
      return '<a class="wsp-card" href="' + p.url + '"><img src="' + (p.img || '') + '" alt="" loading="lazy"><span class="meta">' +
        '<span class="t">' + esc(p.title) + '</span>' +
        (p.sub ? '<span class="s">' + esc(p.sub) + '</span>' : '') +
        '<span class="p">' + priceBlock + '</span></span></a>';
    }
    function catLinks(list) { return list.map(function (c) { return '<a href="' + c[1] + '">' + esc(c[0]) + '</a>'; }).join(''); }
    var catGender = 'damen';
    // Ausgangszustand: Damen/Herren-Umschalter + Chips
    function catsInitial() {
      var list = catGender === 'herren' ? CAT_HERREN : CAT_DAMEN;
      catWrap.innerHTML =
        '<div class="wsp-genderwrap">' +
          '<span class="wsp-genderlabel">' + (i18n.forLabel || 'Für:') + '</span>' +
          '<div class="wsp-switch" data-active="' + catGender + '">' +
            '<span class="wsp-switch-ind"></span>' +
            '<button type="button" data-g="damen"' + (catGender === 'damen' ? ' class="active"' : '') + '>' + (i18n.women || 'Damen') + '</button>' +
            '<button type="button" data-g="herren"' + (catGender === 'herren' ? ' class="active"' : '') + '>' + (i18n.men || 'Herren') + '</button>' +
          '</div>' +
        '</div>' +
        '<div class="wsp-catchips">' + catLinks(list) + '</div>';
    }
    // Suchergebnis: flache Treffer-Chips
    function catsFlat(list) { catWrap.innerHTML = '<div class="wsp-catchips">' + catLinks(list) + '</div>'; }
    // Umschalter (delegiert, übersteht das Neu-Rendern)
    catWrap.addEventListener('click', function (e) {
      var b = e.target.closest('.wsp-switch button'); if (!b) return;
      e.preventDefault();
      catGender = b.getAttribute('data-g');
      // Switch umschalten: Indikator gleitet (CSS-transition), nur die Chips neu aufbauen
      var sw = catWrap.querySelector('.wsp-switch');
      if (sw) {
        sw.setAttribute('data-active', catGender);
        [].forEach.call(sw.querySelectorAll('button'), function (btn) { btn.classList.toggle('active', btn.getAttribute('data-g') === catGender); });
      }
      var chips = catWrap.querySelector('.wsp-catchips');
      if (chips) chips.innerHTML = catLinks(catGender === 'herren' ? CAT_HERREN : CAT_DAMEN);
    });
    function setTop() { var t = Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom)); panel.style.top = t + 'px'; backdrop.style.top = t + 'px'; }

    function loadBest() {
      if (bestCache) return Promise.resolve(bestCache);
      return Promise.all(BEST.map(function (b) {
        return fetch('/products/' + b.handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var price = j.price, compareAt = j.compare_at_price, img = j.featured_image || (j.images && j.images[0]) || '', url = '/products/' + b.handle, sub = j.type || '';
            if (b.variant) {
              var v = (j.variants || []).filter(function (x) { return x.id === b.variant; })[0];
              if (v) { price = v.price; compareAt = v.compare_at_price; if (v.featured_image && v.featured_image.src) img = v.featured_image.src; url += '?variant=' + b.variant; }
            }
            return { title: b.label, price: (price / 100), compareAt: (compareAt ? compareAt / 100 : 0), img: img, url: url, sub: sub };
          })
          .catch(function () { return { title: b.label, price: '', img: '', url: '/products/' + b.handle, sub: '' }; });
      })).then(function (a) { bestCache = a; return a; });
    }

    function loadFill() {
      if (fillCache) return Promise.resolve(fillCache);
      var skip = {};
      BEST.forEach(function (b) { skip[b.handle] = 1; });
      return fetch('/products.json?limit=40', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          fillCache = (j.products || [])
            .filter(function (p) { return FILL_TYPES[p.product_type] && !skip[p.handle] && p.images && p.images[0]; })
            .slice(0, FILL_COUNT)
            .map(function (p) { var v = p.variants && p.variants[0]; return { title: p.title, price: (v ? v.price : ''), compareAt: (v && v.compare_at_price ? v.compare_at_price : 0), img: p.images[0].src, url: '/products/' + p.handle, sub: p.product_type }; });
          return fillCache;
        })
        .catch(function () { fillCache = []; return fillCache; });
    }

    function isMobile() { return window.matchMedia('(max-width:989px)').matches; }

    function showInitial() {
      titleEl.textContent = i18n.popularProducts || 'Beliebte Produkte';
      allEl.setAttribute('href', i18n.viewAllUrl || '/collections/clogs-holzschuhe-woody');
      catsInitial();
      // Mobile: nur die 4 Bestseller (große 2×2-Karten). Desktop: + aufgefüllt auf 10.
      var jobs = isMobile() ? [loadBest(), Promise.resolve([])] : [loadBest(), loadFill()];
      Promise.all(jobs).then(function (a) {
        products.innerHTML = a[0].concat(a[1]).map(card).join('');
      });
    }

    function showResults(q) {
      titleEl.textContent = i18n.resultsTitle || 'Produkte';
      var searchBase = i18n.searchUrl || '/search';
      allEl.setAttribute('href', searchBase + '?q=' + encodeURIComponent(q));
      var params = new URLSearchParams();
      params.set('q', q);
      params.append('resources[type]', 'product,collection');
      params.append('resources[limit]', '10');
      fetch('/search/suggest.json?' + params.toString(), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var res = (j.resources && j.resources.results) || {};
          var prods = (res.products || []).map(function (p) { return { title: p.title, price: p.price, compareAt: (p.compare_at_price || 0), img: (p.image || (p.featured_image && p.featured_image.url) || ''), url: p.url, sub: p.product_type || '' }; });
          var cols = (res.collections || []).map(function (c) { return [c.title, c.url]; });
          if (cols.length) catsFlat(cols); else catsInitial();
          var noResultsTpl = i18n.noResults || 'Keine Treffer für „{q}“';
          products.innerHTML = prods.length ? prods.map(card).join('') : '<div class="wsp-empty">' + noResultsTpl.replace('{q}', esc(q)) + '</div>';
        })
        .catch(function () { products.innerHTML = '<div class="wsp-empty">' + (i18n.unavailable || 'Suche nicht verfügbar') + '</div>'; });
    }

    // iOS-feste Scroll-Sperre: Position merken, body fixieren (via CSS-Klasse), spaeter zurueck
    function lockScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.dataset.wspY = y;
      document.documentElement.classList.add('wsp-lock'); // CSS setzt body auf position:fixed
      document.body.style.top = (-y) + 'px';              // haelt die Seite optisch an Ort und Stelle
    }
    function unlockScroll() {
      var y = parseInt(document.body.dataset.wspY || '0', 10);
      document.documentElement.classList.remove('wsp-lock');
      document.body.style.top = '';
      delete document.body.dataset.wspY;
      window.scrollTo(0, y); // exakt an die vorherige Scroll-Position zurueck
    }

    // iOS: andere Eingabefelder bei offener Suche deaktivieren -> Tastatur zeigt keine "Feld vor/zurueck"-Pfeile mehr
    var wspLockedFields = [];
    function disableOtherFields(active) {
      wspLockedFields = [];
      var sel = 'input[type=text],input[type=search],input[type=email],input[type=tel],input[type=url],input[type=number],input[type=password],input:not([type]),textarea';
      [].forEach.call(document.querySelectorAll(sel), function (el) {
        if (el === active || el.disabled) return;
        el.disabled = true; wspLockedFields.push(el);
      });
    }
    function restoreOtherFields() {
      wspLockedFields.forEach(function (el) { el.disabled = false; });
      wspLockedFields = [];
    }

    function open(input) {
      activeInput = input;
      lockScroll();
      setTop();
      backdrop.classList.add('open');
      panel.classList.add('open');
      disableOtherFields(input);
      // X im aktiven Suchfeld einblenden (sichtbar solange offen)
      var w = input.closest('.header-search-wrap, .mobile-search-wrap');
      var c = w && w.querySelector('.wsp-clear'); if (c) c.classList.add('show');
      var v = (input.value || '').trim();
      if (v.length >= 2) showResults(v); else showInitial();
    }
    function close() {
      unlockScroll();
      restoreOtherFields();
      backdrop.classList.remove('open');
      panel.classList.remove('open');
      // alle X-Buttons wieder ausblenden
      [].forEach.call(document.querySelectorAll('.wsp-clear'), function (c) { c.classList.remove('show'); });
    }

    function bind(input) {
      if (!input || input.dataset.wspBound) return;
      input.dataset.wspBound = '1';
      input.addEventListener('focus', function () { open(input); });
      input.addEventListener('input', function () {
        clearTimeout(debTimer);
        var v = input.value.trim();
        debTimer = setTimeout(function () { if (v.length >= 2) showResults(v); else showInitial(); }, 180);
      });
      // Clear/Close-Button (X) im Suchfeld, wie Snocks: sichtbar solange die Suche offen ist
      var wrap = input.closest('.header-search-wrap, .mobile-search-wrap');
      if (wrap && !wrap.querySelector('.wsp-clear')) {
        input.classList.add('has-clear');
        var clr = document.createElement('button');
        clr.type = 'button';
        clr.className = 'wsp-clear';
        clr.setAttribute('aria-label', i18n.clearAria || 'Suche leeren');
        clr.innerHTML = '&times;';
        wrap.appendChild(clr);
        clr.addEventListener('click', function (e) {
          e.preventDefault();
          if (input.value.trim()) { input.value = ''; input.focus(); showInitial(); } // Text da -> leeren
          else { close(); }                                                            // leer -> Suche schliessen
        });
      }
    }
    bind(document.querySelector('.header-search-input'));
    bind(document.querySelector('.mobile-search-input'));

    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', function () { if (panel.classList.contains('open')) setTop(); });

    // Burger-Menü bei offener Suche: Das Menü (.mobile-nav-wrapper) liegt mit z-index 999 unter dem
    // Such-Overlay (Backdrop 9998 / Panel 9999) -> ein Tap auf den Burger oeffnet es zwar (Theme-JS),
    // bleibt aber unsichtbar dahinter verdeckt = wirkt wie ein toter Klick (bestehendes Verhalten,
    // auch auf Live). Fix: sobald das Menü aktiv wird, waehrend die Suche offen ist, Suche schliessen,
    // damit ein Tap beides erledigt: Suche zu, Menü sichtbar auf.
    var mobileNavWrap = document.querySelector('.mobile-nav-wrapper');
    if (mobileNavWrap) {
      new MutationObserver(function () {
        if (mobileNavWrap.classList.contains('active') && panel.classList.contains('open')) close();
      }).observe(mobileNavWrap, { attributes: true, attributeFilter: ['class'] });
    }

    // Mobile: beim Scrollen im Overlay die Tastatur schliessen, damit Pillen/Links
    // schon auf den ERSTEN Tipp reagieren (sonst schliesst der erste Tipp nur die Tastatur)
    var wspInner = panel.querySelector('#wsp-inner');
    var blurActiveInput = function () { if (activeInput) activeInput.blur(); };
    if (wspInner) {
      wspInner.addEventListener('scroll', blurActiveInput, { passive: true });
      wspInner.addEventListener('touchmove', blurActiveInput, { passive: true });
    }

    window.__wspReady = true;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ============================================================
   woody® — Liefer-Datum im Cart-Drawer ("Lieferung ca. <Datum>")
   Berechnet 1-3 Werktage ab Versandtag (Bestellschluss 16:00 Wien, Wochenende uebersprungen), dt. Format.
   Re-fuellt bei Cart-Drawer-Updates (AJAX).
   ============================================================ */
(function () {
  var isDE = (document.documentElement.lang || 'de').toLowerCase().indexOf('de') === 0;
  var WD = isDE ? ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'] : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function wienJetzt() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Vienna' })); }
  function addBiz(basis, n) { var r = new Date(basis); var c = 0; while (c < n) { r.setDate(r.getDate() + 1); var d = r.getDay(); if (d !== 0 && d !== 6) c++; } return r; }
  function fmt(x) { return isDE ? (WD[x.getDay()] + ' ' + x.getDate() + '.' + (x.getMonth() + 1) + '.') : (WD[x.getDay()] + ' ' + (x.getMonth() + 1) + '/' + x.getDate()); }
  function target() {
    var w = wienJetzt(), tag = w.getDay();
    var o = ((tag !== 0 && tag !== 6) && w.getHours() < 16) ? 0 : 1;
    return fmt(addBiz(w, 1 + o)) + ' – ' + fmt(addBiz(w, 3 + o));
  }
  function fill() { var el = document.getElementById('woody-delivery'); if (el) { var t = target(); if (el.textContent !== t) el.textContent = t; } }
  function start() {
    fill();
    var host = document.querySelector('cart-drawer');
    if (host) { new MutationObserver(fill).observe(host, { childList: true, subtree: true }); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ============================================================
   woody® — Cart-Drawer: Hintergrund-Scroll sperren (iOS-fest)
   Desktop: overflow:hidden (CSS). Mobil: body position:fixed +
   Scroll-Position merken/wiederherstellen (gleiches Prinzip wie die
   Suchleisten-Sperre). Getriggert durch body.overflow-hidden (Drawer auf/zu).
   ============================================================ */
(function () {
  var scY = 0, locked = false;
  function isMobile() { return window.matchMedia('(max-width: 600px)').matches; }
  function apply() {
    var on = document.body.classList.contains('overflow-hidden');
    if (on && !locked) {
      locked = true;
      if (isMobile()) {
        scY = window.scrollY || window.pageYOffset || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = (-scY) + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      }
    } else if (!on && locked) {
      locked = false;
      if (document.body.style.position === 'fixed') {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, scY);
      }
    }
  }
  function start() {
    new MutationObserver(apply).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ============================================================
   woody® — Klarna-Ratenhinweis auf der Produktseite unter den Preis holen
   (er steht standardmaessig unter dem Kauf-Button). Klarna laedt async,
   daher mit kurzer Beobachtung.
   ============================================================ */
(function () {
  function run() {
    if (!document.body || !document.body.classList.contains('template-product')) return true; // nur Produktseite
    var kp = document.querySelector('klarna-placement');
    var priceWr = document.querySelector('.psinglePriceWr');
    if (!kp || !priceWr) return false;
    var block = kp.closest('.shopify-app-block') || kp.parentElement;
    if (block && priceWr.nextElementSibling !== block) {
      priceWr.insertAdjacentElement('afterend', block);
      block.style.marginTop = '10px';
    }
    return true;
  }
  function start() {
    if (run()) return;
    var tries = 0;
    var iv = setInterval(function () { if (run() || ++tries > 25) clearInterval(iv); }, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
